<script setup>
import { useRouter } from 'vue-router';
import { useStoreGetters } from 'dashboard/composables/store';

defineProps({
  integrationId: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const getters = useStoreGetters();
const accountId = getters.getCurrentAccountId;

const goBack = () => {
  router.push({
    name: 'settings_applications',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="flex flex-col items-center justify-center p-12 max-w-lg mx-auto text-center">
    <div
      class="flex items-center justify-center w-16 h-16 rounded-full bg-n-amber-3 mb-6"
    >
      <i class="i-ph-warning text-3xl text-n-amber-9" />
    </div>

    <h2 class="text-xl font-semibold text-n-slate-12 mb-3">
      {{ $t('INTEGRATION_SETTINGS.NOT_CONFIGURED.TITLE') }}
    </h2>
    <p class="text-n-slate-11 text-sm mb-8 leading-relaxed">
      {{ $t('INTEGRATION_SETTINGS.NOT_CONFIGURED.DESCRIPTION') }}
    </p>

    <button
      class="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-n-container text-n-slate-11 text-sm font-medium hover:bg-n-alpha-2 transition-colors"
      @click="goBack"
    >
      <i class="i-ph-arrow-left" />
      {{ $t('INTEGRATION_SETTINGS.NOT_CONFIGURED.GO_BACK') }}
    </button>
  </div>
</template>
